import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Indicates if the screen is in a mobile view or not
 */
const UseIsMobile = () => {
  // const theme = useTheme();
  // const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const matches = useMediaQuery("(max-width:600px)");
  return matches;
};

export default UseIsMobile;
